.intro {
  color: var(--graphite);
  font: var(--t-small);
}

.list {
  margin: 0;
  padding: 0;
  border-top: 1px solid var(--rule);
  list-style: none;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  min-height: var(--row-height-dense);
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--rule);
}
